import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=2f32ce7c&scoped=true&"
import script from "./EditMessage.vue?vue&type=script&lang=js&"
export * from "./EditMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditMessage.vue?vue&type=style&index=0&id=2f32ce7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32ce7c",
  null
  
)

export default component.exports